import './NavItems.css'

import React from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'

import { Menu } from 'primereact/menu'
import { MenuItem } from 'primereact/menuitem'

export default function NavItems({
  setSidebarClassName,
  setMaskClassName,
}: {
  setSidebarClassName: any
  setMaskClassName: any
}): React.ReactElement {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()

  // onClick of the nav items the sidebar should close in mobile view
  const toggleSidebarClassName = (): any => {
    if (window.innerWidth <= 992) {
      setSidebarClassName('navClosed')
      setMaskClassName('')
    }
  }

  const homeMenuItems: MenuItem[] = [
    {
      label: 'Home',
      icon: 'pi pi-home', // <FontAwesomeIcon icon="home" />
      command: () => {
        navigate(`/`)
        toggleSidebarClassName()
      },
      className: isActiveClassName(`/`),
    },
  ]
  const menuItems: MenuItem[] = homeMenuItems
  const mainMenuItem: MenuItem = { label: undefined, items: [] }
  const settingsMenuItem: MenuItem = {
    label: undefined,
    items: [
      {
        label: t('common.navigation.settingsLabel'),
        icon: 'pi pi-cog', // fas fa-cog
        command: () => {
          navigate(`/settings`)
          // toggleSidebarClassName() don't close the nav because you want to navigate faster otherwise you have to click twice on the menu
        },
        className: isActiveClassName(`/settings`),
      },
    ],
  }

  if (location.pathname.startsWith('/settings')) {
    const settingsMenuItems: MenuItem[] = [
      // {
      //   label: t('common.navigation.settings.appconfig'),
      //   icon: 'pi pi-list',
      //   command: () => {
      //       navigate(`/settings/app-config`)
      //       toggleSidebarClassName()
      // },
      //   className: isActiveClassName(`/settings/app-config`),
      // },
      {
        label: t('common.navigation.settings.adapters'),
        icon: 'pi pi-share-alt', //fas fa-share-alt
        command: () => {
          navigate(`/settings/adapters`)
          toggleSidebarClassName()
        },
        className: isActiveClassName(`/settings/adapters`),
      },
      {
        label: t('common.navigation.settings.services'),
        icon: 'pi pi-sitemap', // fas fa-users-cog
        command: () => {
          navigate(`/settings/services`)
          toggleSidebarClassName()
        },
        className: isActiveClassName(`/settings/services`),
      },
      {
        label: t('common.navigation.settings.members'),
        icon: 'pi pi-users', // fas fa-users-cog
        command: () => {
          navigate(`/settings/members`)
          toggleSidebarClassName()
        },
        className: isActiveClassName(`/settings/members`),
      },
      {
        label: t('common.navigation.settings.templates'),
        icon: 'pi pi-list',
        command: () => {
          navigate(`/settings/templates`)
          toggleSidebarClassName()
        },
        className: isActiveClassName(`/settings/templates`),
      },
      {
        label: t('common.navigation.settings.parameters'),
        icon: 'pi pi-globe', // fas fa-users-cog
        command: () => {
          navigate(`/settings/globalparameters`)
          toggleSidebarClassName()
        },
        className: isActiveClassName(`/settings/globalparameters`),
      },
      {
        label: t('common.navigation.settings.apikeys'),
        icon: 'pi pi-key', // fas fa-users-cog
        command: () => {
          navigate(`/settings/apikeys`)
          toggleSidebarClassName()
        },
        className: isActiveClassName(`/settings/apikeys`),
      },
      {
        label: t('common.navigation.settings.customize'),
        icon: 'pi pi-palette', // fas fa-users-cog
        command: () => {
          navigate(`/settings/customize`)
          toggleSidebarClassName()
        },
        className: isActiveClassName(`/settings/customize`),
      },
      {
        label: t('common.navigation.settings.tenantfiles'),
        icon: 'pi pi-folder', // fas fa-users-cog
        command: () => {
          navigate(`/settings/tenantFiles`)
          toggleSidebarClassName()
        },
        className: isActiveClassName(`/settings/tenantFiles`),
      },
      {
        label: t('common.navigation.settings.configTransfer'),
        icon: 'pi pi-arrow-right-arrow-left', // fas fa-users-cog
        command: () => {
          navigate(`/settings/config-transfer`)
          toggleSidebarClassName()
        },
        className: isActiveClassName(`/settings/config-transfer`),
      },
    ]
    mainMenuItem.label = t('common.navigation.settingsLabel')
    mainMenuItem.items = settingsMenuItems
  }

  if (location.pathname.startsWith('/projects')) {
    const projectId = getProjectId(location.pathname)
    const projectPath = '/projects/' + projectId
    const projectMenuItems: MenuItem[] = [
      // {
      //   label: t('common.navigation.overview'),
      //   icon: 'pi pi-id-card',
      //   command: () => {
      //       navigate(`${projectPath}`)
      //       toggleSidebarClassName()
      // },
      //   className: isActiveClassName(`${projectPath}`),
      // },
      {
        label: t('common.navigation.projects.details'),
        icon: 'pi pi-pencil', // fas fa-pencil
        command: () => {
          navigate(`${projectPath}/details`)
          toggleSidebarClassName()
        },
        className: isActiveClassName(`${projectPath}/details`),
      },
      {
        label: t('common.navigation.projects.files'),
        icon: 'pi pi-folder', // fas fa-users
        command: () => {
          navigate(`${projectPath}/files`)
          toggleSidebarClassName()
        },
        className: isActiveClassName(`${projectPath}/files`),
      },
      {
        label: t('common.navigation.projects.services'),
        icon: 'pi pi-sitemap', // fas fa-sitemap
        command: () => {
          navigate(`${projectPath}/services`)
          toggleSidebarClassName()
        },
        className: isActiveClassName(`${projectPath}/services`),
      },
      // {
      //   label: t('common.navigation.projects.forms'),
      //   icon: 'pi pi-file',
      //   command: () => {
      //   navigate(`${projectPath}/forms`)
      //   toggleSidebarClassName()
      // },
      //   disabled: true,
      // },
      {
        label: t('common.navigation.projects.members'),
        icon: 'pi pi-users', // fas fa-users
        command: () => {
          navigate(`${projectPath}/members`)
          toggleSidebarClassName()
        },
        className: isActiveClassName(`${projectPath}/members`),
      },
      // {
      //   label: t('common.navigation.projects.stats'),
      //   icon: 'pi pi-chart-line',
      //   command: () => {
      //     navigate(`${projectPath}/stats`)
      //     toggleSidebarClassName()
      // },
      //   disabled: true,
      // },
      // {
      //   label: t('common.navigation.projects.logs'),
      //   icon: 'pi pi-list',
      //   command: () => {
      // navigate(`${projectPath}/logs`)
      // toggleSidebarClassName()
      // },
      //   disabled: true,
      // },
      {
        label: t('common.navigation.projects.properties'),
        icon: 'pi pi-sliders-h',
        command: () => {
          navigate(`${projectPath}/properties`)
          toggleSidebarClassName()
        },
        className: isActiveClassName(`${projectPath}/properties`),
      },
      {
        label: t('common.navigation.projects.json'),
        icon: 'pi pi-file', // fas fa-users
        command: () => {
          navigate(`${projectPath}/json`)
          toggleSidebarClassName()
        },
        className: isActiveClassName(`${projectPath}/json`),
      },
    ]
    mainMenuItem.label = t('common.navigation.microAppLabel')
    mainMenuItem.items = projectMenuItems
  }

  menuItems.push(mainMenuItem)
  menuItems.push(settingsMenuItem)

  return <Menu model={menuItems} />
}

function getProjectId(path: string): string {
  const firstIndex = path.indexOf('/', 1)
  const secondIndex = path.indexOf('/', '/projects/'.length)
  const projectId = path.substring(firstIndex + 1, secondIndex > 0 ? secondIndex : path.length)
  // console.log(projectId)
  return projectId
}

function isActiveClassName(path: string): string {
  return location.pathname === path ? 'active' : ''
}
